<div class="container">
    <section class="inner-container">
        <section class="secondary-header formHeader">
            <div class="title">
                <button type="button" class="btn btn-primary has-back-icon" (click)="change('Services')"><i class="icons icon-previous"></i> Services</button> &emsp;
                <div class="title-mobile">Onboarding Form - Pre-Form Declaration  </div>
            </div>
        </section>

        <main class="grey-bg">
            <div class="products" style="background: white">
                <div class="content-container">
                    <div class="text-center">
                        <h1 class="title-default intro-title">Declaration</h1>
                        <hr class="yellow-line-large">
                        <p class="text-intro">
                            You are minutes away from setting up your new service. <br/><br/>
                            To speed up the process, ensure that your business registration and directorship details are available for easy reference.
                        </p>
                    </div>
                    <div class="inner">
                        <div class="flex-wrap scroll_declaration" style="text-align: center">
                            <form name="declaration" id="declaration" data-k2-validation="true" novalidate class="col-sm-8 general-form" style="padding: 0">          
                                <p [ngClass]="{red: !valid && !dec.value}"> Please tick the checkbox below: </p>
                                <div class="row boxx" style="text-align: initial;">
                                    <div class="col-md-12">
                                        <div class="checkbox-default">
                                            <label class="norm" for="dec"> 
                                                <input data-rules="required" data-error-mes="This field is required" type="checkbox" name="dec" [(ngModel)]="declaration" #dec="ngModel" id="dec" required><span></span>
                                                 I /We give consent to the Bank to verify and/or make any checks and/or obtain any information and/or from confirmation, with or from any credit reference agencies, including but not limited to CTOS, CCRIS, FIS and/or any other agencies and/or from any financial institution, on me/us and/or any other person, individual and/or entity as the Bank may deem fit, for any purposes which the Bank deems fit.
                                            </label>
                                            <br>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-5">
                                    </div>                    
                                    <div class="col-md-3">
                                        <button class="btn btn-primary btn-block" (click)="validate()">Submit</button> 
                                    </div>
                                    <div class="col-md-4">
                                    </div>                    
                                </div>
                            </form>
                        </div> 
                    </div>
                </div>
            </div>
        </main>
    </section>
</div>